import React, { PureComponent } from 'react'
import { Row } from 'react-bootstrap'
import { Field } from 'redux-form'
import InputText from '../../../commons/form/InputText'
import { permissions } from '../../../../constants/backendIds'
import NormalizedAddress from '../client/NormalizedAddress'

class Contact extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      alert: true,
      allInformationDisabled: true,
      disableCountry: false,
      disableState: false,
      disableCity: false,
      disableTown: false,
      disableColony: false,
      disableCP: false
    }
  }

  disableEntityAddressCombos () {
    this.setState({
      disableCountry: !!this.props.dossier.entityComponent.stateCode,
      disableState: !!this.props.dossier.entityComponent.cityCode,
      disableCity: !!this.props.dossier.entityComponent.townCode,
      disableTown: !!this.props.dossier.entityComponent.colonyCode,
      disableColony: !!this.props.dossier.entityComponent.postalCodeCode,
      disableCP: !this.props.dossier.entityComponent.colonyCode
    })
  }

  handleEntityCountryChange (code) {
    if (code) {
      this.props.actions.fetchEntityStateTypeCombo(this.props.combos.entityCountryTypeCombo?.find(x => x.code === code)?.id)
      this.setState({ disableCountry: true, disableState: false })
    }
  }

  handleEntityStateChange (code) {
    if (code) {
      this.props.actions.fetchEntityCityTypeCombo(this.props.combos.entityStateTypeCombo?.find(x => x.code === code)?.id)
      this.setState({ disableState: true, disableCity: false })
    } else {
      this.setState({ disableCountry: false, disableState: true })
    }
  }

  handleEntityCityChange (code) {
    if (code) {
      this.props.actions.fetchEntityTownTypeCombo(this.props.combos.entityCityTypeCombo?.find(x => x.code === code)?.id)
      this.setState({ disableCity: true, disableTown: false })
    } else {
      this.setState({ disableState: false, disableCity: true })
    }
  }

  handleEntityTownChange (code) {
    if (code) {
      this.props.actions.fetchEntityColonyTypeCombo(this.props.combos.entityTownTypeCombo?.find(x => x.code === code)?.id)
      this.setState({ disableTown: true, disableColony: false })
    } else {
      this.setState({ disableCity: false, disableTown: true })
    }
  }

  handleEntityColonyChange (code) {
    if (code) {
      this.props.actions.fetchEntityCPTypeCombo(this.props.combos.entityColonyTypeCombo?.find(x => x.code === code)?.id)
      this.setState({ disableColony: true, disableCP: false })
    } else {
      this.setState({ disableTown: false, disableColony: true })
    }
  }

  handleEntityCPChange (code) {
    if (!code) {
      this.setState({ disableColony: false, disableCP: true })
    }
  }

  validateSchema () {
    const {
      fieldsConfiguration
    } = this.props
    return (
      (fieldsConfiguration.contactStartStreet && fieldsConfiguration.contactStartStreet.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactEnndStreet && fieldsConfiguration.contactEnndStreet.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactExternalNumber && fieldsConfiguration.contactExternalNumber.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactInternalNumber && fieldsConfiguration.contactInternalNumber.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactCountryCode && fieldsConfiguration.contactCountryCode.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactStateCode && fieldsConfiguration.contactStateCode.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactCityCode && fieldsConfiguration.contactCityCode.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactTownCode && fieldsConfiguration.contactTownCode.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactColonyCode && fieldsConfiguration.contactColonyCode.permission !== permissions.hidden) ||
     (fieldsConfiguration.contactCpCode && fieldsConfiguration.contactCpCode.permission !== permissions.hidden)
    )
  }

  shortSchema () {
    const {
      t,
      fieldsConfiguration,
      readOnlyFields,
      disabledByNotSelectedEntityTypeId
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.ENTITY.'
    return (<Row>
      {fieldsConfiguration.contactName &&
            fieldsConfiguration.contactName.permission !==
              permissions.hidden && (
        <Field
          colSm={4}
          id="contactName"
          name="dossierContactComponent.contactName"
          key="dossierContactComponent.contactName"
          controlLabel={t(`${tKey}CONTACT_NAME`)}
          placeholder={t(`${tKey}CONTACT_NAME`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactName.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactSurname1 &&
            fieldsConfiguration.contactSurname1.permission !==
              permissions.hidden && (
        <Field
          colSm={4}
          id="contactSurname1"
          name="dossierContactComponent.contactSurname1"
          key="dossierContactComponent.contactSurname1"
          controlLabel={t(`${tKey}CONTACT_SURNAME1`)}
          placeholder={t(`${tKey}CONTACT_SURNAME1`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactSurname1.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactSurname2 &&
            fieldsConfiguration.contactSurname2.permission !==
              permissions.hidden && (
        <Field
          colSm={4}
          id="contactSurname2"
          name="dossierContactComponent.contactSurname2"
          key="dossierContactComponent.contactSurname2"
          controlLabel={t(`${tKey}CONTACT_SURNAME2`)}
          placeholder={t(`${tKey}CONTACT_SURNAME2`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactSurname2.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactEmail &&
            fieldsConfiguration.contactEmail.permission !==
              permissions.hidden && (
        <Field
          id="contactEmail"
          name="dossierContactComponent.contactEmail"
          key="dossierContactComponent.contactEmail"
          colSm={4}
          controlLabel={t(`${tKey}EMAIL`)}
          placeholder={t(`${tKey}EMAIL`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactEmail.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactPhone &&
            fieldsConfiguration.contactPhone.permission !==
              permissions.hidden && (
        <Field
          id="contactPhone"
          name="dossierContactComponent.contactPhone"
          key="dossierContactComponent.contactPhone"
          colSm={4}
          controlLabel={t(`${tKey}PHONE`)}
          placeholder={t(`${tKey}PHONE`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactPhone.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactMobilePhone &&
            fieldsConfiguration.contactMobilePhone.permission !==
              permissions.hidden && (
        <Field
          id="contactMobilePhone"
          name="dossierContactComponent.contactMobilePhone"
          key="dossierContactComponent.contactMobilePhone"
          colSm={4}
          controlLabel={t(`${tKey}MOBILE`)}
          placeholder={t(`${tKey}MOBILE`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactMobilePhone
                    .permission !== permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactAddress &&
            fieldsConfiguration.contactAddress.permission !==
              permissions.hidden && (
        <Field
          id="contactAddress"
          name="dossierContactComponent.contactAddress"
          key="dossierContactComponent.contactAddress"
          colSm={4}
          controlLabel={t(`${tKey}ADDRESS`)}
          placeholder={t(`${tKey}ADDRESS`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactAddress.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactCity &&
            fieldsConfiguration.contactCity.permission !==
              permissions.hidden && (
        <Field
          id="contactCity"
          name="dossierContactComponent.contactCity"
          key="dossierContactComponent.contactCity"
          colSm={4}
          controlLabel={t(`${tKey}CITY`)}
          placeholder={t(`${tKey}CITY`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactCity.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactState &&
            fieldsConfiguration.contactState.permission !==
              permissions.hidden && (
        <Field
          id="contactState"
          name="dossierContactComponent.contactState"
          key="dossierContactComponent.contactState"
          colSm={4}
          controlLabel={t(`${tKey}STATE`)}
          placeholder={t(`${tKey}STATE`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactState.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactCp &&
            fieldsConfiguration.contactCp.permission !==
              permissions.hidden && (
        <Field
          id="contactCp"
          name="dossierContactComponent.contactCp"
          key="dossierContactComponent.contactCp"
          colSm={4}
          controlLabel={t(`${tKey}CP`)}
          placeholder={t(`${tKey}CP`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactCp.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
      {fieldsConfiguration.contactCountry &&
            fieldsConfiguration.contactCountry.permission !==
              permissions.hidden && (
        <Field
          id="contactCountry"
          name="dossierContactComponent.contactCountry"
          key="dossierContactComponent.contactCountry"
          colSm={4}
          controlLabel={t(`${tKey}COUNTRY`)}
          placeholder={t(`${tKey}COUNTRY`)}
          component={InputText}
          disabled={
            readOnlyFields ||
                  fieldsConfiguration.contactCountry.permission !==
                    permissions.editable ||
                  disabledByNotSelectedEntityTypeId
          }
        />
      )}
    </Row>
    )
  }

  longSchema () {
    const {
      t,
      fieldsConfiguration,
      readOnlyFields,
      disabledByNotSelectedEntityTypeId,
      actions: {
        fetchEntityCountryTypeCombo,
        fetchEntityStateTypeCombo,
        fetchEntityCityTypeCombo,
        fetchEntityTownTypeCombo,
        fetchEntityColonyTypeCombo,
        fetchEntityCPTypeCombo,
        fetchClientDataAddress
      }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.ENTITY.'
    return (
      <Row className='flexRow'>
        {fieldsConfiguration.contactName &&
          fieldsConfiguration.contactName.permission !==
            permissions.hidden && (
          <Field
            colSm={4}
            id="contactName"
            name="dossierContactComponent.contactName"
            key="dossierContactComponent.contactName"
            controlLabel={t(`${tKey}CONTACT_NAME`)}
            placeholder={t(`${tKey}CONTACT_NAME`)}
            component={InputText}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactName.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
          />
        )}
        {fieldsConfiguration.contactSurname1 &&
          fieldsConfiguration.contactSurname1.permission !==
            permissions.hidden && (
          <Field
            colSm={4}
            id="contactSurname1"
            name="dossierContactComponent.contactSurname1"
            key="dossierContactComponent.contactSurname1"
            controlLabel={t(`${tKey}CONTACT_SURNAME1`)}
            placeholder={t(`${tKey}CONTACT_SURNAME1`)}
            component={InputText}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactSurname1.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
          />
        )}
        {fieldsConfiguration.contactSurname2 &&
          fieldsConfiguration.contactSurname2.permission !==
            permissions.hidden && (
          <Field
            colSm={4}
            id="contactSurname2"
            name="dossierContactComponent.contactSurname2"
            key="dossierContactComponent.contactSurname2"
            controlLabel={t(`${tKey}CONTACT_SURNAME2`)}
            placeholder={t(`${tKey}CONTACT_SURNAME2`)}
            component={InputText}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactSurname2.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
          />
        )}
        {fieldsConfiguration.contactEmail &&
          fieldsConfiguration.contactEmail.permission !==
            permissions.hidden && (
          <Field
            id="contactEmail"
            name="dossierContactComponent.contactEmail"
            key="dossierContactComponent.contactEmail"
            colSm={4}
            controlLabel={t(`${tKey}EMAIL`)}
            placeholder={t(`${tKey}EMAIL`)}
            component={InputText}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactEmail.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
          />
        )}
        {fieldsConfiguration.contactPhone &&
          fieldsConfiguration.contactPhone.permission !==
            permissions.hidden && (
          <Field
            id="contactPhone"
            name="dossierContactComponent.contactPhone"
            key="dossierContactComponent.contactPhone"
            colSm={4}
            controlLabel={t(`${tKey}PHONE`)}
            placeholder={t(`${tKey}PHONE`)}
            component={InputText}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactPhone.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
          />
        )}
        {fieldsConfiguration.contactMobilePhone &&
          fieldsConfiguration.contactMobilePhone.permission !==
            permissions.hidden && (
          <Field
            id="contactMobilePhone"
            name="dossierContactComponent.contactMobilePhone"
            key="dossierContactComponent.contactMobilePhone"
            colSm={4}
            controlLabel={t(`${tKey}MOBILE`)}
            placeholder={t(`${tKey}MOBILE`)}
            component={InputText}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactMobilePhone
                  .permission !== permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
          />
        )}
        <NormalizedAddress
          t={t}
          fieldsConfiguration={{
            countryCode: fieldsConfiguration.contactCountryCode,
            stateCode: fieldsConfiguration.contactStateCode,
            cityCode: fieldsConfiguration.contactCityCode,
            townCode: fieldsConfiguration.contactTownCode,
            colonyCode: fieldsConfiguration.contactColonyCode,
            cpCode: fieldsConfiguration.contactCpCode
          }}
          readOnlyFields={readOnlyFields}
          allInformationDisabled={disabledByNotSelectedEntityTypeId}
          entityComponent= {this.props.dossier.dossierContactComponent}
          entityTypeName= "dossierContactComponent"
          actions={{
            fetchEntityCountryTypeCombo,
            fetchEntityStateTypeCombo,
            fetchEntityCityTypeCombo,
            fetchEntityTownTypeCombo,
            fetchEntityColonyTypeCombo,
            fetchEntityCPTypeCombo,
            fetchClientDataAddress
          }}
          change = {this.props.actions.change}
        />

        {fieldsConfiguration.contactAddress &&
          fieldsConfiguration.contactAddress.permission !==
            permissions.hidden && (
          <Field
            id="contactAddress"
            name="dossierContactComponent.contactAddress"
            key="dossierContactComponent.contactAddress"
            colSm={8}
            controlLabel={t(`${tKey}ADDRESS`)}
            placeholder={t(`${tKey}ADDRESS`)}
            component={InputText}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactAddress.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
          />
        )}
        {fieldsConfiguration.contactExternalNumber && fieldsConfiguration.contactExternalNumber.permission !== permissions.hidden && (
          <Field
            id="externalNumber"
            name="dossierContactComponent.externalNumber"
            key="dossierContactComponent.externalNumber"
            colSm={4}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactExternalNumber.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
            controlLabel={t(`${tKey}EXTERNAL_NUMBER`)}
            placeholder={t(`${tKey}EXTERNAL_NUMBER`)}
            component={InputText}
            maxLength="20"
          />
        )}
        {fieldsConfiguration.contactStartStreet && fieldsConfiguration.contactStartStreet.permission !== permissions.hidden && (
          <Field
            id="startStreet"
            name="dossierContactComponent.startStreet"
            key="dossierContactComponent.startStreet"
            colSm={8}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactStartStreet.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
            controlLabel={t(`${tKey}START_STREET`)}
            placeholder={t(`${tKey}START_STREET`)}
            component={InputText}
            maxLength="200"
          />
        )}
        {fieldsConfiguration.contactInternalNumber && fieldsConfiguration.contactInternalNumber.permission !== permissions.hidden && (
          <Field
            id="internalNumber"
            name="dossierContactComponent.internalNumber"
            key="dossierContactComponent.internalNumber"
            colSm={4}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactInternalNumber.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
            controlLabel={t(`${tKey}INTERNAL_NUMBER`)}
            placeholder={t(`${tKey}INTERNAL_NUMBER`)}
            component={InputText}
            maxLength="200"
          />
        )}
        {fieldsConfiguration.contactEnndStreet && fieldsConfiguration.contactEnndStreet.permission !== permissions.hidden && (
          <Field
            id="enndStreet"
            name="dossierContactComponent.enndStreet"
            key="dossierContactComponent.enndStreet"
            colSm={8}
            disabled={
              readOnlyFields ||
                fieldsConfiguration.contactEnndStreet.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityTypeId
            }
            controlLabel={t(`${tKey}ENND_STREET`)}
            placeholder={t(`${tKey}ENND_STREET`)}
            component={InputText}
            maxLength="20"
          />
        )}
      </Row>
    )
  }

  render () {
    return (
      <div>
        { !this.validateSchema() ? (
          this.shortSchema()
        ) : (
          this.longSchema()
        ) }
      </div>
    )
  }
}

export default Contact
